import React from 'react';
import * as PropTypes from 'prop-types';

// Local components
import CvModal from '../components/base/SimpleModal';
import CalculateStatisticsForm from '../components/forms/CalculateStatisticsForm';
import RWSaltComponent from './RWSaltComponent';

/**
 * Calculate Statistics component to show the statistical data of list
 */
class RWCalculateStatistics extends RWSaltComponent {
    static propTypes = {
        xStyle: PropTypes.oneOfType([
            PropTypes.object,
            PropTypes.array,
        ]),
        title: PropTypes.string,
        onCancel: PropTypes.func,
        columns: PropTypes.arrayOf(PropTypes.object),
        rows: PropTypes.arrayOf(PropTypes.object),
    };

    render() {
        const {
            onCancel,
            xStyle,
            ...restProps
        } = this.props;

        const calculateStatisticsFormProps = {
            contextStyles: RWSaltComponent.extractCombinedStyles(xStyle),
            onCancel,
            ...restProps,
        };
        const contextStyles = {
            modal: {
                overflow: 'hidden',
            },
            modalColumnContainer: {
                overflow: 'auto',
            },
        };
        return (
            <CvModal
                contextStyles={ contextStyles }
                onPressOverlay={ onCancel }>
                { React.createElement(CalculateStatisticsForm, { ...calculateStatisticsFormProps }) }
            </CvModal>
        );
    }
}

export default RWCalculateStatistics;